import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/**
 * Displays a checklist item with drag handle, input, edit/delete buttons, and metadata
 */
const SortableChecklistItem = ({ item, index, onChange, onDelete, onEdit, itemTypes = [] }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: item._uiId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.8 : 1,
    background: "#fff",
    borderRadius: 8,
    padding: 8,
  };

  const typeLabel = itemTypes.find(t => t.value === item.item_type)?.label || item.item_type;
  const requiredLabel = item.is_required ? "Required" : "Optional";
  const photoLabel = item.require_photo ? "Photo Required" : "";
  const noteLabel = item.require_note ? "Note Required" : "";

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="uk-flex uk-flex-middle uk-flex-between uk-margin-small-bottom"
    >
      <div style={{ flex: 1 }}>
        <div className="uk-flex uk-flex-middle" style={{ gap: 8 }}>
          <button
            className="uk-button hms-simple-icon-btn"
            type="button"
            aria-label="Drag to reorder"
            {...attributes}
            {...listeners}
            style={{ cursor: "grab" }}
          >
            <img src="/images/move.svg" alt="Move" />
          </button>

          <input
            className="uk-input uk-width-expand"
            type="text"
            value={item.label}
            onChange={(e) => onChange({ ...item, label: e.target.value }, index)}
          />

          <button
            type="button"
            className="uk-button uk-button-text"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onEdit(item);
            }}
            aria-label="Edit task"
          >
            <img src="/images/edit-icon.svg" alt="Edit" />
          </button>

          <button
            className="uk-button hms-simple-icon-btn"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete(index);
            }}
            aria-label="Delete item"
          >
            <img src="/images/delete-icon.svg" alt="Delete" />
          </button>
        </div>

        <div
          className="uk-text-mute uk-margin-small-left"
          style={{ marginTop: 4, cursor: "pointer", color: "#999" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onEdit(item);
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onEdit(item);
          }}
        >
          Type: {typeLabel} • {requiredLabel}
          {photoLabel && ` • ${photoLabel}`}
          {noteLabel && ` • ${noteLabel}`}
        </div>
      </div>
    </div>
  );
};

export default SortableChecklistItem;
